// Phase-A R5 — Co-brand footer for the redesigned login.
//
// S-REBRAND-EMI موج ۳ — کوبرندِ پیشین طبقِ تصمیمِ مالک برداشته شد؛
// جای آن سطرِ حقوقیِ مجریِ فنی می‌نشیند. متنِ `legalFa` عیناً و یک‌تکه رندر
// می‌شود چون متنِ مصوبِ حقوقی است، نه کپیِ قابلِ ویرایش.
// نشانِ ویستا یک فایل بیشتر ندارد (روی دیسکِ سفید ساخته شده) و روی سطحِ
// روشن و تیره هر دو خواناست، پس سوییچِ دو-تصویریِ وابسته به تم لازم نیست.
//
// S-I18N-W4C — چهار پیوندِ فوتر به `identity` رفتند. `legalFa` عمداً نرفت و در
// عربی هم فارسی می‌ماند: استثنایِ ثبت‌شده در `docs/I18N_STRATEGY.md` — متنِ
// مصوبِ حقوقیِ مجریِ فنی است و ترجمهٔ ماشینیِ آن تصمیمِ حقوقی است نه مهندسی.
// اگر روزی نسخهٔ عربیِ مصوب برسد، در `brand.config.ts` کنارِ `legalFa` می‌نشیند.
import React from "react";
import { useTranslation } from "react-i18next";
import { BRAND } from "../../brand/brand.config";

const FootLink: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <a
    href="#"
    onClick={(e) => e.preventDefault()}
    style={{
      color: "var(--r5-muted)",
      textDecoration: "none",
      transition: "color 160ms ease",
    }}
    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = "var(--r5-ink)"; }}
    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = "var(--r5-muted)"; }}
  >
    {children}
  </a>
);

const VistaMark: React.FC = () => (
  <img
    src={BRAND.developer.mark}
    alt={BRAND.developer.nameFa}
    width="40"
    height="40"
    loading="lazy"
    decoding="async"
    className="r5-vista-mark"
  />
);

export const CoBrandFooter: React.FC = () => {
  const { t } = useTranslation("identity");
  return (
    <footer
    style={{
      marginTop: "clamp(28px, 5vh, 56px)",
      paddingTop: 20,
      borderTop: "1px solid var(--r5-line)",
      display: "flex",
      flexWrap: "wrap",
      gap: 18,
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: 11.5,
      color: "var(--r5-muted)",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 12, maxWidth: 560 }}>
      <VistaMark />
      <span style={{ lineHeight: 1.6, color: "var(--r5-ink-2)" }}>
        {BRAND.developer.legalFa}
      </span>
    </div>
    <nav style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
      <FootLink>{t("login.coBrand.linkLegal")}</FootLink>
      <FootLink>{t("login.coBrand.linkSupport")}</FootLink>
      <FootLink>{t("login.coBrand.linkStatus")}</FootLink>
      <FootLink>{t("login.coBrand.linkApi")}</FootLink>
    </nav>
    </footer>
  );
};

export default CoBrandFooter;
